module.exports = __webpack_public_path__ + "img/request-access-status.27be7da.png";